import axiosConfig from "./axiosConfig";

interface HhDataEditResponse {
  success: boolean;
  message?: string;
}

const postHhDataEdit = async (
  authToken: string,
  fileGuid: string
): Promise<HhDataEditResponse> => {
  const { data } = await axiosConfig.post(
    `/hh_data/${fileGuid}/edit`,
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default postHhDataEdit;
